import { Block } from "./block";

export function OrganizationAnalysis() {
  return <Block type="Organization Analysis">OrganizationAnalysis</Block>;
}
